import { Button, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const Category = styled.article``;

const CategoryHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;

  ${Typography.S.Typography} {
    min-width: fit-content;
  }
`;

const CategoryItems = styled.div`
  display: flex;
  gap: 8px;
  margin: 16px 0;
  overflow-x: scroll;
  width: 100%;
`;

const CategorySwiper = styled.div`
  margin-top: 16px;
  position: relative;

  .swiper-wrapper {
    gap: 16px;
  }
`;

const NavigationButtonFrame = styled.div`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 48px;
  z-index: 3;

  // there are 2 button frame
  // make the last one to the right
  &:first-child {
    background: linear-gradient(90deg, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);
    left: 0;

    ${Button.S.Button} {
      transform: rotate(180deg);

      &:hover {
        transform: rotate(180deg) scale(1.2);
      }
    }
  }
  &:last-child {
    background: linear-gradient(270deg, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);
    right: 0;
  }
`;

const NavigationButton = styled(Button)`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-circle);
  height: 32px;
  min-width: 32px;
  padding: 12px;
  transition: all 0.3s ease-in-out;
  width: 32px;

  &:hover {
    background-color: var(--color-accent-primary-default);
    border-color: var(--color-accent-primary-default);
    color: var(--color-fg-inverse-default);
    transform: scale(1.2);
  }
`;

const CategoryContentEmpty = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  color: var(--color-accent-secondary-weaker);
  display: flex;
  gap: 24px;
  height: 200px;
  justify-content: center;
  margin: 16px 0;

  ${DEVICE.mobile.max} {
    flex-direction: column;
    font-size: 12px;
    gap: 8px;
  }
`;

export {
  Category,
  CategoryContentEmpty,
  CategoryHeader,
  CategoryItems,
  CategorySwiper,
  NavigationButton,
  NavigationButtonFrame
};
